import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import I18n from 'utils/I18n';
import ActionsCameraNormalSmall from '@strava/icons/ActionsCameraNormalSmall';
import Button from '@strava/ui/Button';
import Popup from '@strava/ui/Popup';
import createNetworkingClient from 'utils/networking-client';
import styles from './MediaUploader.scss';

// TODO: For testing purposes.  Workaround to having to set up canaries constantly
window.createNetworkingClient = createNetworkingClient;
function MediaUploader({ athleteId }) {
  const [files, setFiles] = useState([]);

  // For a single given media file, get URL to send it to
  async function getMediaUrl(file) {
    const path = `/photos/metadata`;
    const mediaType = /video/.test(file.type) ? 2 : 1;

    // TODO: Look into crypto UUID potentially
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      (c) => {
        // eslint-disable-next-line no-bitwise
        const r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );

    try {
      const result = await createNetworkingClient().put(path, {
        athlete_id: athleteId,
        uuid,
        taken_at: file.lastModified,
        media_type: mediaType
      });
      return result;
    } catch (error) {
      return {
        error: {
          message: `${error.name}: ${error.message}`,
          debug: {
            path
          }
        }
      };
    }
  }

  // Store media at given URL
  async function storeMedia(data, file) {
    const { uri, header } = data;

    try {
      const result = await createNetworkingClient().put(uri, file, {
        headers: { 'Content-Type': header['Content-Type'] }
      });
      return result;
    } catch (error) {
      return {
        error: {
          message: `${error.name}: ${error.message}`,
          debug: {
            uri
          }
        }
      };
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: ['image/*', 'video/*'],
    onDrop: (acceptedFiles) => {
      // TODO: Need to rework this api request, but this is it for now for iteration 1
      acceptedFiles.forEach(async (file) => {
        const result = await getMediaUrl(file);
        console.log('acceptedFiles result', result); // TODO: Will remove
        // TODO: For testing purposes.  Workaround to having to set up canaries constantly
        const result2 = await (window.storeMedia || storeMedia)(
          result.data,
          file
        );
        console.log('acceptedFiles result2', result2); // TODO: Will remove
      });
      setFiles([
        ...files,
        ...acceptedFiles.map((file) => {
          // TODO: Add in API calls to get URL to send media to
          // then send media to URL
          return Object.assign(file, {
            // TODO: Figure out how to best make preview image for video
            preview: URL.createObjectURL(file)
          });
        })
      ]);
    },
    maxSize: 100000000, // 100 mb
    onError: (error) => {
      // TODO: Make a better error handling
      console.log(error.message);
    }
  });

  const setHighlightMedia = (e, index) => {
    // TODO: Need to add logic to set highlight
    e.preventDefault();
    e.stopPropagation();
    console.log(index);
  };

  const remove = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    const newFiles = [...files];
    newFiles.splice(index, 1);
    setFiles(newFiles);
    // TODO: Need to add api call to remove photo
  };

  const thumbnails = files.map((file, index) => (
    <div className={styles.thumbnailContainer} key={file.name}>
      <div className={styles.thumbnail}>
        <Popup
          contents={
            <ul className={styles.mediaPopup}>
              <li>
                <Button
                  className={styles.mediaPopupButton}
                  onClick={(e) => {
                    setHighlightMedia(e, index);
                  }}
                >
                  {I18n.t(`templates.activities.edit.photos.set_highlight`)}
                </Button>
              </li>
              <li>
                <Button
                  className={styles.mediaPopupButton}
                  onClick={(e) => {
                    remove(e, index);
                  }}
                >
                  {I18n.t(`templates.activities.edit.photos.remove`)}
                </Button>
              </li>
            </ul>
          }
          position="top"
        >
          <input
            type="image"
            src={file.preview}
            className={styles.thumbnailImage}
            // Revoke data uri after image is loaded
            onLoad={() => {
              URL.revokeObjectURL(file.preview);
            }}
            alt={file.name}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onKeyDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          />
        </Popup>
      </div>
    </div>
  ));

  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, []);

  return (
    <div>
      {/* TODO: Change this to whatever we want it called in new design */}
      <div className={styles.label}>Media</div>
      <div {...getRootProps({ className: styles.dropzone })}>
        <input {...getInputProps()} />
        {files.length === 0 && (
          <>
            {/* TODO: Change this to whatever we want it in new design - Placeholder */}
            <ActionsCameraNormalSmall fill="#b2afc0" />
            <p className={styles.header}>
              {I18n.t(`templates.photos.form.dropzone_header`)}
            </p>
            <p className={styles.subheader}>
              {I18n.t(`templates.photos.form.dropzone_sub`)}
            </p>
          </>
        )}
        {thumbnails.length > 0 && (
          <div className={styles.mediaContainer}>{thumbnails}</div>
        )}
      </div>
    </div>
  );
}

MediaUploader.propTypes = {
  athleteId: PropTypes.number.isRequired
};

export default MediaUploader;
